import { JstNumerical, JstSubmission } from '../../models/inputTypes/JstFields';

export const simsFileslInitialObject = { file: undefined };

export const jstNumericalInitialState: JstNumerical = {
  project: '',
  simulationSetup: undefined,
  simsFiles: [simsFileslInitialObject],
};

export const jstSubmissionInitialState: JstSubmission = {
  simulationFile: '',
};
